import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "usages",
  templateUrl: "./usages.component.html",
})
export class UsagesComponent implements OnInit {

  @Input() public locations: any[] = [];
  @Input() public usages: any;
  @Input() public type: string;

  public showUsagesPerLocation: {[key: string]: boolean} = {};

  public ngOnInit(): void {
    this.locations.forEach((l) => {
      this.showUsagesPerLocation[l] = true;
      if (this.usages[l]?.length) {
        this.usages[l].sort((a, b) => {
          const nameA = a.name.toLowerCase() || a.label.toLowerCase() || a.title.toLowerCase();
          const nameB = b.name.toLowerCase() || b.label.toLowerCase() || b.title.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
      }
    });
  }

  public format(item) {
    switch (this.type) {
      case "message":
        return this.formatForMessages(item);
      default:
        return item;
    }
  }

  public formatForMessages(item) {
    const service = item.split(":")[0];
    const temp = item.split(":")[1];
    const middle = temp.split(" - ")[0];
    const end = temp.split(" - ")[1];
    let formatted = `<span class="badge badge-light mr-2">${service}</span> ${middle}`;
    if (end) {
      formatted += `<span class="badge ml-auto badge-${this.formatLabel(end)}">${end}</span>`;
    }
    return  formatted;
  }

  public formatLabel(lbl) {
    switch (lbl) {
      case "FILE PENDING":
        return "info";
      case "FILE VALIDATED":
        return "success";
      case "SEND BACK TO CORRECTIONS":
        return "warning";
      case "FILE REJECT":
        return "danger";
      default:
        return "default";
    }
  }
}
